import { isDemoHost } from '@/config/demo';
import { isEsportsDemoHost } from '@/config/esportsDomain';

interface BrowserLocationParts {
  hostname: string;
  protocol: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
}

/**
 * Return the equivalent URL on the primary sports host for a route opened on
 * the read-only sports demo host. Local `demo.localhost` development keeps its
 * protocol and port; the esports demo is owned by its separate vertical.
 */
export function getPrimaryAppUrl(location: BrowserLocationParts): string | null {
  if (!isDemoHost(location.hostname) || isEsportsDemoHost(location.hostname)) {
    return null;
  }

  const primaryHostname = location.hostname.replace(/^demo\./, '');
  const port = location.port ? `:${location.port}` : '';
  return `${location.protocol}//${primaryHostname}${port}${location.pathname}${location.search}${location.hash}`;
}
